import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col, Table } from 'react-bootstrap';
import fetch from '../../core/fetch/fetch.server';
import waiting from './waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { fetchDistrictServices } from '../../actions/district';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, buttonPayStyle } from '../../components/utils/utils';
import { PanelStyle } from '../../constants';
import ModalAlert from '../eservices/ModalAlert';


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const statOptions = [
  {
    state: 'statOption',
    value: '0',
    label: 'Lista gmin wdrożonych',
  },
  {
    state: 'statOption',
    value: '1',
    label: 'Lista gmin z aktywnym certyfikatem PZ',
  },
  {
    state: 'statOption',
    value: '2',
    label: 'Lista gmin bez aktywnego certyfikatu PZ',
  },
  {
    state: 'statOption',
    value: '3',
    label: 'Lista gmin, w których certyfikat PZ wygaśnie w ciągu 30 dni',
  },
  {
    state: 'statOption',
    value: '4',
    label: 'Lista gmin z wdrożonym logowaniem WK',
  },
  {
    state: 'statOption',
    value: '5',
    label: 'Lista gmin z aktywnym certyfikatem WK',
  },
  {
    state: 'statOption',
    value: '6',
    label: 'Lista gmin bez aktywnego certyfikatu WK',
  },
  {
    state: 'statOption',
    value: '7',
    label: 'Lista gmin, w których certyfikat WK wygaśnie w ciągu 30 dni',
  },
  {
    state: 'statOption',
    value: '8',
    label: 'Lista gmin z wdrożonym logowaniem WK, gdzie certyfikat WK jest aktualny, a certyfikat PZ wygasł',
  },
];

const col_header_map = {
  CertInfo_Emails: 'Adresy email do powiadomień',
  Epuap_Addresses: 'Adresy skrytek ePUAP Jednostki',
  Is_WK: 'Czy uruchomiony WK',
  Name: 'Nazwa Jednostki',
  PZ_Cert_expiration_date: 'Data wygaśnięcia cert. PZ',
  PZ_Cert_expiration_days: 'Pozostało dni do wygaśnięcia cert. PZ',
  WK_Cert_expiration_date: 'Data wygaśnięcia cert. WK',
  WK_Cert_expiration_days: 'Pozostało dni do wygaśnięcia cert. WK',
};

const filterDict = {
  '0': stat => stat.Prefix != null,
  '1': stat => stat.PZ_actual == true,
  '2': stat => stat.PZ_actual == false,
  '3': stat => stat.PZ_Cert_expiration_days != 'Brak danych' && stat.PZ_Cert_expiration_days <= 30,
  '4': stat => stat.Is_WK == true,
  '5': stat => stat.WK_actual == true,
  '6': stat => stat.WK_actual == false,
  '7': stat => stat.WK_Cert_expiration_days != 'Brak danych' && stat.WK_Cert_expiration_days <= 30,
  '8': stat => stat.WK_actual == true && stat.PZ_actual == false,
}

class ZestawieniaGminne extends React.Component {

  state = {
    statOption: '0',
    stats: [],
    visible_columns: [
      'Name',
      'CertInfo_Emails',
      'Epuap_Addresses',
      'PZ_Cert_expiration_date',
      'PZ_Cert_expiration_days',
      'Is_WK',
      'WK_Cert_expiration_date',
      'WK_Cert_expiration_days'
    ],
    statsFilter: stat => stat.Prefix != null,
    statsDate: null,
    isMounted: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    
  };

  componentDidMount() {
    this.prepareColors();
    this.getStats();
  }

  prepareColors = () => {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  async getStats(refresh=false) {
    const url = `${process.env.API_URL}/eservices/epuap_cert_info/${refresh ? 0 : this.state.statOption}/`;
    await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({'userID': this.props.userData.userId})
    })
      .then(r => r.json())
      .then(stats => {
        const now = new Date().toLocaleString();
        this.setState({ stats, isMounted: true, statsDate: now });
      });
  }

  changeFilter = () => {
    const option = this.state.statOption;
    this.setState({ statsFilter: filterDict[option], isMounted: true })
  }

  onChangeStat = (e) => {
    this.setState(
      {
        statOption: e.value,
        isMounted: false,
      },
      () => this.changeFilter(),
    );
  };

  onHide = () => this.setState({ showError: false });

  renderRow = (value, idx) => {
    const number = idx + 1;
    return (
      <tr key={idx}>
        <td>{number}</td>
        {this.state.visible_columns.map((col, col_index) => this.renderCol(col, col_index, value))}
      </tr>
    );
  };

  renderCol = (key, idx, data) => {
    if (key === 'Is_WK') {
      return <td key={`${key}${idx}`}>{data[key] ? 'TAK' : 'NIE'}</td>;
    }
    return <td key={`${key}${idx}`}>{data[key]}</td>;
  }

  renderView = () => {
    return (
      <GrayPanel title="Zestawienia Gminne">
        <Grid style={{ width: '100%' , heigth: '500px'}}>
          <Row>
            <Col xs={12}>
              <div className="row mobile-row" key={'SelectRow'} style={rowStyle}>
                <div className={leftCol} />
                <div className={labelCol}>
                  <label style={labelStyle}>Wybrane zestawienie</label>
                </div>

                <div className={inputCol}>
                <Select
                  noResultsText={'brak wyników'}
                  clearable={false}
                  options={statOptions}
                  value={this.state.statOption}
                  placeholder={'Wybierz z listy...'}
                  onChange={e => this.onChangeStat(e)}
                  onBlur={event => event.preventDefault()}
                  optionClassName="needsclick"
                  blurInputOnSelect={false}
                />
                </div>
                <div className={rightCol} />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <Table condensed>
                  <thead>
                    <tr>
                      <th>#</th>
                      {this.state.visible_columns.map((key, idx) => {
                        return <th key={idx}>{col_header_map[key]}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.stats.filter(this.state.statsFilter).length === 0 ? (
                      <tr>
                        <td colSpan="100%">
                          <p
                            style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '10px' }}
                          >
                            nie znaleziono obiektów spełniających podane kryteria
                          </p>
                        </td>
                      </tr>
                    ) : (
                      this.state.stats
                        .filter(this.state.statsFilter)
                        .map((val, idx) => this.renderRow(val, idx))
                    )}
                  </tbody>
                </Table>
            </Col>
          </Row>
          <Row style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
            <Col xs={10}>
              <p style={{ margin: '0' }}>Data pobrania danych: {this.state.statsDate}</p>
            </Col>
            <Col xs={2}>
              <button
                onClick={() => this.setState({ isMounted: false }, () => this.getStats(true))}
                className="btn btn-primary pull-right mobile-button"
                style={buttonPayStyle}
              >
                Odśwież
              </button>
            </Col>
          </Row>
        </Grid>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </GrayPanel>
    );
  }

  render() {
    return (this.state.isMounted ? this.renderView() : (
      <GrayPanel
        title="Trwa ładowanie zawartości..."
        bodyStyle={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
      >
        <img alt="Loader" src={waiting} />
      </GrayPanel>))

  }
}

const mapState = state => ({

  username: state.user ? state.user.username : '',
  districts: state.district.districts,
  all_eservices: state.district.districtServicesData
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles()(connect(mapState, mapDispatch)(ZestawieniaGminne));



// WEBPACK FOOTER //
// src/routes/ZestawieniaGminne/ZestawieniaGminne.jsx